import { useMutation } from '@apollo/client';
import { Stack, Heading } from 'braid-design-system';

import REMOVE_PREFERENCE_KEYWORD from '../../queries/removePreferenceKeyword';
import AddPreference from '../AddPreference/AddPreference';
import ListItem from '../ListItem/ListItem';

interface Props {
  keywords: any[];
  refetch: () => void;
}

const Keywords = ({ keywords, refetch }: Props) => {
  const [removePreferencesKeyword] = useMutation(REMOVE_PREFERENCE_KEYWORD);
  const removeKeyword = (keyword: string) => () =>
    removePreferencesKeyword({
      variables: {
        input: keyword,
      },
    }).then(refetch);
  return (
    <Stack space="medium">
      <Heading level="4">Keywords</Heading>

      {keywords.length > 0 && (
        <Stack space="medium">
          {keywords.map((keyword, k) => (
            <ListItem
              key={k}
              itemLabel={keyword}
              remove={removeKeyword(keyword)}
            />
          ))}
        </Stack>
      )}

      <AddPreference preference="keyword" refetchAll={refetch} />
    </Stack>
  );
};

export default Keywords;
